import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import PasswordReset from "./PasswordReset";
import SetNewPassword from "./SetNewPassword";

import DailyContent from "./DailyContent";
import WellnessGym from "./WellnessGym"
import Onboarding from "./Onboarding";
import OnboardingDemo from "./OnboardingDemo";
import LandingForm from "./LandingForm";
import LandingFormBeta from "./LandingFormBeta"
import ImportResources from "./ImportResources";
import Home from "./Home";
// import Welcome from "./Welcome"
import Profile from "./Profile"
import Progress from "./Progress"
import ProblematicLog from "./ProblematicLog"
import Support from "./Support";
import Settings from "./Settings";
import About from "./About";
import PreLoad from "./PreLoad";
import InDevelopment from "./InDevelopment";
import Notifications from "./Notifications";
import Chat from "./ChatDemo2";
// import ChatDemo from "./ChatDemo";
import HomeDemo from "./HomeDemo";
import Sandbox from "./Sandbox";
import { ChromeConnect, ConnectSuccess } from "./ChromeConnect";



import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
import { useEffect, useState } from "react";
import axios from 'axios';
import { resetUserSession, setUserSession, getToken, getUser } from "./service/AuthService";

import './css/Main.css';
import './css/Daily.css';

const verifyUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/verify';

function App() {

  const [isAuthenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    let mounted = true;
    const token = getToken();
    if (token === 'undefined' || token === undefined || token === null || !token) {
      setAuthenticating(false);
      return () => {
        mounted = false;
      };
    }

    const requestConfig = {
      headers: {
        'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
      },
      timeout: 10000,
    };

    const requestBody = {
      user: getUser(),
      token: token
    };

    axios
      .post(verifyUrl, requestBody, requestConfig)
      .then((response) => {
        if (!mounted) return;
        setUserSession(response.data.user, response.data.token);
      })
      .catch(() => {
        if (!mounted) return;
        resetUserSession();
      })
      .finally(() => {
        if (!mounted) return;
        setAuthenticating(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const token = getToken();
  if (isAuthenticating && token) {
    return <div className="content">Authenticating...</div>
  }

  return (
    <div className="App" style={{  display: 'flex', flexFlow: 'column', margin:'0 auto'}}>
      <div className="donut-parent" >
        <div 
          className="donut" 
          style={{
          // position: 'absolute',
          // top: '50%',
          // left: '45%',
          // transform: 'translate(-0%, -50%)'  
        }}
      ></div>
      </div>
      <BrowserRouter>
        <div className = "header sticky">
          <div className="dailyBottomNav" role="navigation" aria-label="Primary">
            {/* <NavLink to="/relapse" className={({ isActive }) => `dailyBottomNavItem${isActive ? ' isActive' : ''}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
              <span>Setback</span>
            </NavLink> */}
            <NavLink to="/daily-content" className={({ isActive }) => `dailyBottomNavItem${isActive ? ' isActive' : ''}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
              <span>Home</span>
            </NavLink>
            <NavLink to="/progress" className={({ isActive }) => `dailyBottomNavItem${isActive ? ' isActive' : ''}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V8m5 12V4m6 16v-9m5 9V6" /></svg>
              <span>Progress</span>
            </NavLink>
            <NavLink to="/wellness-gym" className={({ isActive }) => `dailyBottomNavItem${isActive ? ' isActive' : ''}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20 20 4M7 4h13v13" /></svg>
              <span>Gym Floor</span>
            </NavLink>
            <NavLink to="/support" className={({ isActive }) => `dailyBottomNavItem${isActive ? ' isActive' : ''}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 11a4 4 0 1 0-8 0M4 20a8 8 0 0 1 16 0" /></svg>
              <span>Support</span>
            </NavLink>
          </div>
        </div>
        {/* <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1.5rem'}}>
          <img style={{ width: '95%', maxWidth: '335px', maxHeight: '75px' }} src={logoBold} alt="Example" />
        </div> */}
        <div>
          <Routes>
            <Route path="*" element={<Login />} /> 
            <Route exact path="/" element={<PreLoad />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/password-reset" element={<PasswordReset />}/>
            <Route path="/set-new-password" element={<SetNewPassword />}/>
            <Route path="/landing-form" element={<LandingForm />}/>
            <Route path="/landing-form-beta" element={<LandingFormBeta />}/>
            <Route path="/connect" element={<ChromeConnect />}/>
            <Route path="/profile" element={<Profile />}/>

            <Route element={<PublicRoutes/>}>
              <Route path="/register" element={<Register />}/>
            </Route>
            <Route element={<PrivateRoutes/>}>
              <Route path="/connect-success" element={<ConnectSuccess />}/>
              <Route path="/home" element={<Home />}/>
              <Route path="/import-resources" element={<ImportResources />}/>
              <Route path="/daily-content" element={<DailyContent />}/>
              <Route path="/onboarding" element={<Onboarding />}/>
              <Route path="/onboarding-demo" element={<OnboardingDemo />}/>
              <Route path="/progress" element={<Progress />}/>
              <Route path="/relapse" element={<ProblematicLog />}/>
              <Route path="/support" element={<Support />}/>
              <Route path="/settings" element={<Settings />}/>
              <Route path="/about" element={<About />}/>
              <Route path="/in-development" element={<InDevelopment />}/>
              <Route path="/notifications" element={<Notifications />}/>
              {/* <Route path="/pre-load" element={<PreLoad />}/> */}
              <Route path="/chat" element={<Chat />}/>
              <Route path="/wellness-gym" element={<WellnessGym />}/>
              {/* <Route path="/chat-demo" element={<ChatDemo />}/> */}
              <Route path="/home-demo" element={<HomeDemo />}/>
              <Route path="/sand-box" element={<Sandbox />}/>
            </Route>
          </Routes>
        </div>
      </BrowserRouter>    
    </div>
  );
}

export default App;
